import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { ESlice } from '@enums/redux.enum';

type InitialState = {
	flightNumber?: string;
	token?: string;
	vehicleId?: number;
	isAuthenticated: boolean;
	error?: string;
	isLoading: boolean;
	isRefreshing: boolean;
};

const initialState: InitialState = {
	flightNumber: undefined,
	token: undefined,
	vehicleId: undefined,
	isAuthenticated: false,
	error: undefined,
	isLoading: false,
	isRefreshing: false,
};

const authSlice = createSlice({
	name: ESlice.auth,
	initialState,
	reducers: {
		setToken: (state, { payload }: PayloadAction<string | undefined>) => {
			state.token = payload;
			state.error = undefined;
		},
		setFlightNumber: (state, { payload }: PayloadAction<string>) => {
			state.flightNumber = payload;
			state.isRefreshing = true;
			if (state.token && state.flightNumber) {
				state.isAuthenticated = true;
			}
			state.error = undefined;
		},
		reset: (state) => {
			state.error = undefined;
			state.isLoading = false;
			state.isRefreshing = false;
			state.vehicleId = undefined;
		},
		setError: (state, { payload }: PayloadAction<string | undefined>) => {
			state.error = payload;
			state.isLoading = false;
		},
		setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
			state.isLoading = payload;
		},
		setIsRefreshing: (state, { payload }: PayloadAction<boolean>) => {
			state.isRefreshing = payload;
		},
		setVehicleId: (state, { payload }: PayloadAction<number | undefined>) => {
			state.vehicleId = payload;

			if (state.token && payload) {
				state.isAuthenticated = true;
			}
			state.error = undefined;
		},
	},
});

export const { setToken, setFlightNumber, reset, setError, setIsLoading, setIsRefreshing, setVehicleId } = authSlice.actions;

export default authSlice.reducer;
